/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Spinner from "../../../components/icons/Spinner";

function SpinnerButton({ style, className, minWidth }) {
  return (
    <button
      className={"text-button mx-8 spinner-button " + (className || "")}
      data-testid="spinner-button"
      style={{ minWidth, ...style }}
    >
      <Spinner
        className="spinner pos-relative "
        height="16px"
        width="16px"
        fill="#0088D1"
        style={{ top: "2px" }}
      />
    </button>
  );
}

export default SpinnerButton;
